module.exports = __webpack_public_path__ + "static/media/logo-bettorlogic.71c94ede.png";